import { PresetStatusColorType } from 'antd/lib/_util/colors';
import { Tag as ATag } from 'antd';

interface Props {
    status: PresetStatusColorType;
    label: string;
}

const Tag = (props: Props) => {
    return <ATag color={props.status}>{props.label}</ATag>;
};

export default Tag;
